import type { WorkOrderChangeObjectItem, WorkOrderObjectData } from 'gql/graphql';
import { getObjectsTree } from 'pages/Project/UerProject/WorkOrder/AddWorkOrderUer/helpersAndTypes';

import { useMemo } from 'react';

interface ISelectingObjectDataGrid {
    currentDataItems?: (WorkOrderObjectData | WorkOrderChangeObjectItem)[] | null;
    comboxId?: number;
    constructionTypeId?: number;
}

export const useSelectingObjectDataGrid = ({
    currentDataItems,
    constructionTypeId,
    comboxId,
}: ISelectingObjectDataGrid) => {
    const selectedRow = currentDataItems?.find((i) => i?.id === comboxId);

    const workOrderChildObjects = useMemo(
        () =>
            currentDataItems?.filter(
                (obj: { constructionType: { id: number } }) => obj.constructionType?.id === constructionTypeId,
            ),
        [constructionTypeId, currentDataItems],
    );

    const objTree = useMemo(
        () => (selectedRow?.id ? getObjectsTree(workOrderChildObjects ?? [], selectedRow?.id) : []),
        [selectedRow?.id, workOrderChildObjects],
    );

    return useMemo(
        () => [
            {
                id: selectedRow?.id,
                name: selectedRow?.name,
                level: 0,
            },
            ...objTree,
        ],
        [selectedRow?.id, selectedRow?.name, objTree],
    );
};
